import * as React from "react";
import { ReactNode } from "react";

interface CategoryPanelProps {
  children: ReactNode;
  id?: string;
  label: string;
}

export default class CategoryPanel extends React.Component<CategoryPanelProps> {
  render() {
    return (
      <div
        className="category panel with-shadow"
        key={this.props.id}
        id={this.props.id && this.props.id.toLowerCase()}
      >
        <h1 className="title">{this.props.label}</h1>
        {this.props.children}
      </div>
    );
  }
}
